// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__27Bdy","header":"PatientQuestionnaire_header__1ImMl","info":"PatientQuestionnaire_info__3B2H1"};